import React, { Component } from "react";
import logo from './NovaBlitz_Burst_2048sq_Black.png';


var d = new Date();
class Footer extends Component {
  render() {

    var footerStyle = {
      backgroundColor: "#000000",
      color: "white",
      paddingBottom: 20
    };

    var h3Style = {
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    }

    var footerTextStyle = {
      color: "white",
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 10
    }

    var listStyle = {
      listStyle: "none"
    }

    return (
      <footer style={footerStyle} className="footer">
      <div className="container">
          <div className="row">
              <div className="col-md-4" style={footerTextStyle}>
                  <h3 style={h3Style}>Official Links</h3>
                  <ul style={listStyle}>
                    <li>
                      <img src={logo} alt="" /> &nbsp;
                      <a href="https://www.novablitz.com">www.novablitz.com</a>
                    </li>
                    <li>
                      <i className='fab fa-reddit-square fa-3x'></i>&nbsp;&nbsp;&nbsp;&nbsp;
                      <a href="https://www.reddit.com/r/NovaBlitz/">r/NovaBlitz</a>
                    </li>
                    <li>
                      <i className='fab fa-discord fa-3x'></i>&nbsp;&nbsp;&nbsp;&nbsp;
                      <a href="https://discord.gg/7v2S2Na">Discord</a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4" style={footerTextStyle}>
                  <h3 style={h3Style}>Play the Game</h3>
                  <ul style={listStyle}>
                    <li>
                      <i className="fab fa-steam-square fa-3x"></i> &nbsp;<a href="http://store.steampowered.com/app/388370">Download on Steam</a>
                    </li>
                    <li>
                      <i className="fab fa-android fa-3x"></i>&nbsp;
                      <i className="fab fa-apple fa-3x"></i>&nbsp;
                      <a href="https://goo.gl/forms/yC7tMdlERUctx2d53">Sign up for Mobile Beta</a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4" style={footerTextStyle}>
                  <h3 style={h3Style}>Contact & Legal</h3>
                  <p>
                    This site has no affiliation with Dragon Foundry or Nova Blitz.  This is a community site run by a fan.
                  </p>
                  <p>
                    Contact: <a href="mailto:info@novablitzhq.com">info@novablitzhq.com</a>
                  </p>
                  <p>
                    &copy; {d.getFullYear()} - Nova Blitz HQ Team
                  </p>
                </div>
              </div>
          </div>
      </footer>


    );
  }
}

export default Footer;


/*
<footer style={footerStyle} className="footer">
    <div className="container-fluid">
        <div className="row">
            <div className="col" style={footerTextStyle}>
              <h3 style={h3Style}>Official Links</h3>
            </div>
            <div className="col" style={footerTextStyle}>
              <h3 style={h3Style}>Play the Game</h3>
            </div>
            <div className="col" style={footerTextStyle}>
              <h3 style={h3Style}>Contact & Legal</h3>
            </div>
        </div>
        <div className="row">
            <div className="col" style={footerTextStyle}>
              <img src={logo} alt="" /> &nbsp;
              <a href="https://www.novablitz.com">www.novablitz.com</a>
            </div>
            <div className="col" style={footerTextStyle}>
              <i className="fab fa-steam-square fa-3x"></i> &nbsp;<a href="http://store.steampowered.com/app/388370">Download on Steam</a>
            </div>
            <div className="col" style={footerTextStyle}>
              This site has no affiliation with Dragon Foundry or Nova Blitz.  This is a community site run by a fan.
            </div>
        </div>
        <div className="row" style={footerBottomStyle}>
            <div className="col" style={footerTextStyle}>
              <i className='fab fa-reddit-square fa-3x'></i>&nbsp;
              <a href="https://www.reddit.com/r/NovaBlitz/">r/NovaBlitz</a>

              &nbsp;&nbsp;

              <i className='fab fa-discord fa-3x'></i>&nbsp;
              <a href="https://discord.gg/7v2S2Na">Discord</a>
            </div>
            <div className="col" style={footerTextStyle}>
              <i className="fab fa-android fa-3x"></i>&nbsp;
              <i className="fab fa-apple fa-3x"></i>&nbsp;
              <a href="https://goo.gl/forms/yC7tMdlERUctx2d53">Sign up for Mobile Beta</a>
            </div>
            <div className="col" style={footerTextStyle}>
              Contact: <a href="mailto:info@novablitzhq.com">info@novablitzhq.com</a>  &nbsp;&nbsp;  &copy; {d.getFullYear()} - Nova Blitz HQ Team
            </div>
        </div>
    </div>
</footer>
*/



// WEBPACK FOOTER //
// ./src/Footer.js